import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { TimelineDot } from '@material-ui/lab';
const TimelineDotStyle = styled(TimelineDot)(({ theme, styleProps, }) => {
    const { color, variant } = styleProps;
    return {
        ...(variant === 'filled'
            ? {
                '&.MuiTimelineDot-filled': {
                    color: theme.palette[color].contrastText,
                    backgroundColor: theme.palette[color].main,
                },
            }
            : {
                '&.MuiTimelineDot-outlined': {
                    borderColor: theme.palette[color].main,
                },
            }),
    };
});
export function MTimelineDot({ color = 'grey', variant = 'filled', ...other }) {
    const theme = useTheme();
    if (color === 'grey' || color === 'inherit' || color === 'primary' || color === 'secondary') {
        return _jsx(TimelineDot, Object.assign({ color: color, variant: variant }, other), void 0);
    }
    return _jsx(TimelineDotStyle, Object.assign({ variant: variant, styleProps: { color, variant }, theme: theme }, other), void 0);
}
//# sourceMappingURL=MTimelineDot.js.map